import * as moment from 'moment';

export class DateUtil {

    static MY_FORMATS = {
        parse: {
            dateInput: 'MM/DD/YYYY',
        },
        display: {
            dateInput: 'MM/DD/YYYY',
            monthYearLabel: 'MMM YYYY',
            dateA11yLabel: 'MM/DD/YYYY',
            monthYearA11yLabel: 'MMMM YYYY',
        },
    };

    static formatDate(date) {
        return moment(date).format("MM/DD/YYYY");
    }

    static formatDateISO(date) {
        return moment(date).format("YYYY-MM-DD");
    }

    static formatDateTimeISO(date) {
        return moment(date).format("YYYY-MM-DD'T'HH:mm:ss");
    }

    static formatDateTime(date) {
        return moment(date).format("MM/DD/YYYY HH:mm");
    }

    static formatTime(date) {
        return moment(date).format("HH:mm");
    }

    static dateTimeRegex = /([0-1][0-9])(\/)([0-3][0-9])(\/)([2-9][0-9][0-9][0-9]) ([0-2][0-9])\:([0-5][0-9])$|([0-1][0-9])(\/)([0-3][0-9])(\/)([2-9][0-9][0-9][0-9])$/;

    static validateDateTime(dateTime: string): Boolean {
        if (this.dateTimeRegex.test(dateTime) || dateTime === '') {
            return true;
        } else {
            return false;
        }
    }

}
